// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { cleaningProcedureId } from './CleaningProcedure';
import { operatorId } from './Operator';
import { z } from 'zod';
export const cleaningFormId = (z.number());
export const cleaningForm = z.object({
    id: cleaningFormId,
    procedure_id: cleaningProcedureId,
    version: z.string(),
    previous_version_id: cleaningFormId.nullable(),
    name: z.string(),
    description: z.string().nullable(),
    is_default: z.boolean(),
    is_active: z.boolean(),
    sop_markdown: z.string().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
});
export const cleaningFormInitializer = z.object({
    id: cleaningFormId.optional(),
    procedure_id: cleaningProcedureId,
    version: z.string().optional(),
    previous_version_id: cleaningFormId.optional().nullable(),
    name: z.string(),
    description: z.string().optional().nullable(),
    is_default: z.boolean().optional(),
    is_active: z.boolean().optional(),
    sop_markdown: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
export const cleaningFormMutator = z.object({
    id: cleaningFormId.optional(),
    procedure_id: cleaningProcedureId.optional(),
    version: z.string().optional(),
    previous_version_id: cleaningFormId.optional().nullable(),
    name: z.string().optional(),
    description: z.string().optional().nullable(),
    is_default: z.boolean().optional(),
    is_active: z.boolean().optional(),
    sop_markdown: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=CleaningForm.js.map